<template>
	<div id="m_ypxx">
		<div class="g-ypxx">

			<p>
				<span class="ypxx-left">作品名称</span>
				<span class="ypxx-right"><input v-model="movie_name" type="text" placeholder="请输入作品名称"></span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">出品方</span>
				<span class="ypxx-right"><input v-model="make" type="text" placeholder="请输入出品方单位">
				</span>

				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">筹备地点</span>
				<span class="ypxx-right">
					<input v-model="prepare" type="text" placeholder="请输入筹备地点">
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">开机时间</span>
				<span class="ypxx-right">
					<col span="12">
					<el-date-picker v-model="start_time" type="date" placeholder="       选择日期" value-format="yyyy-MM-dd">
					</el-date-picker>
					</col>
				</span>
				<!-- <input type="text" v-model="start_time"> -->
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">拍摄周期</span>
				<span class="ypxx-right"><input v-model="take_period" type="text" placeholder="请输入拍摄周期！例：28">
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">拍摄地点</span>
				<span class="ypxx-right">
					<RadioGroup v-model="take_place">
						<Radio label="1">北京</Radio>
						<Radio label="2">上海</Radio>
						<Radio label="3">浙江横店</Radio>
						<Radio label="4">其他</Radio>
					</RadioGroup>
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">影片类型</span>
				<span class="ypxx-right">
					<RadioGroup v-model="theme">
						<Radio label="1">院线电影</Radio>
						<Radio label="2">网络电影</Radio>
						<Radio label="3">数字电影</Radio>
						<Radio label="4">电视剧</Radio>
						<Radio label="5">网络剧</Radio>
						<Radio label="6">广告拍摄</Radio>
						<Radio label="7">MV拍摄</Radio>
						<Radio label="8">综艺节目</Radio>
						<Radio label="9">演出活动</Radio>
						<Radio label="10">其他</Radio>
					</RadioGroup>
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">剧情简介</span>
				<span class="ypxx-right">
					<textarea v-model="synopsis" class="g-wd-txt" placeholder="限300字以内"></textarea>
				</span>
				<div class=" clearfix"></div>
			</p>
			<p>
				<span class="ypxx-left">影片封面</span>

				<span class="ypxx-right">
					<div class="imgfm float-left" >
						<img :src="imgsrc" width="250" height="350">
					</div>
					<div class="float-right">
						<div class="line" style="">
							<div class="cropper-content" style="">
								<div class="cropper">
									<vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true"
									 :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original"
									 :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"
									 :fixedBox="option.fixedBox" @realTime="realTime" @imgLoad="imgLoad"></vueCropper>
								</div>
							</div>
						</div>
						<center>
							<div class="crop-btn">
								<label class="crop-select-btn" for="uploads">选择</label>
								<input type="file" id="uploads" :value="imgFile" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg"
								 @change="uploadImg($event, 1)">
								<input type="button" class="oper" value="+" title="放大" @click="changeScale(1)">
								<input type="button" class="oper" value="-" title="缩小" @click="changeScale(-1)">
								<label class="crop-select-btn" @click="finish('blob')">裁剪</label>

							</div>
						</center>
					</div>
					<div class="clearfix"></div>
				</span>
				<div class=" clearfix"></div>
			</p>
			<center><input @click="ypxx" type="submit" class="g-btn" value="确认提交"></center>


		</div>
	</div>
</template>

<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	export default {
		data() {
			return {
				crap: false,
				previews: {},
				option: {
					img: '',
					outputSize: 1, //剪切后的图片质量（0.1-1）
					full: false, //输出原图比例截图 props名full
					outputType: 'jpeg',
					canMove: true, //能否拖动图片
					original: false, //是否显示原始宽高
					canMoveBox: false, //能否拖动截图框
					autoCrop: true, //是否自动生成截图框
					autoCropWidth: 250,
					autoCropHeight: 350,
					fixedBox: true // 固定大小 禁止改变截图框大小
				},
				fileName: '', //本机文件地址
				imgFile: '',
				uploadImgRelaPath: '', //上传后的图片的地址（不带服务器域名）
				movie_name: storage.get('movie_name'), //作品名称
				make: storage.get('make'), //出品方
				prepare: storage.get('prepare'), //暂定拍摄地点
				take_place: storage.get('take_place'), //拍摄地点
				start_time: storage.get('start_time'), //开机日期
				take_period: storage.get('take_period'), //暂定拍摄周期
				theme: storage.get('theme'), //影片类型
				synopsis: storage.get('synopsis'), //影片简介
				picture: '', //影片封面
				imgsrc: storage.get('imgsrc'), //本地图片渲染路径
				uid: storage.get('id'), //影片所属id

			}
		},

		methods: {
			changeScale(num) {

				num = num || 1;
				this.$refs.cropper.changeScale(num);
			},

			finish(type) {

				let _this = this;
				// 输出
				if (type === 'blob') {
					this.$refs.cropper.getCropBlob((data) => {
						let img = window.URL.createObjectURL(data)
						this.model = true;
						this.modelSrc = img;
						//将获取到的裁剪后图片信息转成base64格式
						var image = new Image();
						var vm = this
						var reader = new FileReader();
						reader.readAsDataURL(data);
						reader.onload = function(e) {
							vm.imgsrc = e.target.result //将base64信息赋值给需要显示图片的字段
						}
					})
				} else {
					this.$refs.cropper.getCropData((data) => {
						this.model = true;
						this.modelSrc = data;
					})
				}
			},

			// 实时预览函数
			realTime(data) {

				this.previews = data
			},
			//选择本地图片
			uploadImg(e, num) {
				var _this = this;
				var file = e.target.files[0]
				_this.fileName = file.name;
				if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
					alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
					return false
				}
				var reader = new FileReader();
				reader.onload = (e) => {
					let data;
					if (typeof e.target.result === 'object') {
						// 把Array Buffer转化为blob 如果是base64不需要
						data = window.URL.createObjectURL(new Blob([e.target.result]))
					} else {
						data = e.target.result
					}
					if (num === 1) {
						_this.option.img = data
					} else if (num === 2) {
						_this.example2.img = data
					}
				}
				reader.readAsArrayBuffer(file);

			},
			imgLoad(msg) {

			},
			ypxx() {
				var api = 'https://api.yopoo.cn/api/centre/updatecrew'

				let infor = {
					movie_name: this.movie_name, //影片名称
					make: this.make, //出品方
					prepare: this.prepare, //筹备地点
					take_place: this.take_place, //拍摄地点
					start_time: this.start_time, //开机时间
					take_period: this.take_period, //拍摄周期
					theme: this.theme, //影片类型
					synopsis: this.synopsis, //影片简介
					picture: this.imgsrc, //影片封面
					id: storage.get('id') //指定影片id
				}
				Axios.post(api, infor).then((res) => {
					if (res.data.code == '200') {
						this.$message({
							message: res.data.msg,
							type: 'success',
							center: true
						});
						setTimeout(() => {
							location.reload()
						}, 1000);
						storage.del('yp_pic')
					}
					if (res.data.code == '202') {
						this.$message({ //提示发送验证码成功信息
							message: res.data.msg,
							type: 'error',
							center: true
						});
					}
				})
			}
		}
	}
</script>
<style scoped lang="less">
	.info {
		width: 720px;
		margin: 0 auto;

		.oper-dv {
			height: 20px;
			text-align: right;
			margin-right: 100px;

			a {
				font-weight: 500;

				&:last-child {
					margin-left: 30px;
				}
			}
		}

		.info-item {
			margin-top: 15px;

			label {
				display: inline-block;
				width: 100px;
				text-align: right;
			}

			.sel-img-dv {
				position: relative;

				.sel-file {
					position: absolute;
					width: 90px;
					height: 30px;
					opacity: 0;
					cursor: pointer;
					z-index: 2;
				}

				.sel-btn {
					position: absolute;
					cursor: pointer;
					z-index: 1;
				}
			}
		}
	}

	.cropper-content {
		// 		display: flex;
		// 		display: -webkit-flex;
		// 		justify-content: flex-end;
		// 		-webkit-justify-content: flex-end;

		.cropper {
			width: 250px;
			height: 350px;
		}

		.show-preview {
			flex: 1;
			-webkit-flex: 1;
			display: flex;
			display: -webkit-flex;
			justify-content: center;
			-webkit-justify-content: center;

			.preview {
				overflow: hidden;
				border-radius: 50%;
				border: 1px solid #cccccc;
				background: #cccccc;
				margin-left: 40px;
			}
		}
	}

	.cropper-content .show-preview .preview {
		margin-left: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/group_admin/group_modify/M_Ypxx.vue